export const AUTH_CONSTS = {
  moduleName: 'epb-auth',

  getters: {
    token: 'token',
    tokenInfo: 'tokenInfo',
    isLoggedIn: 'isLoggedIn',
    keepLoggedIn: 'keepLoggedIn'
  },
  actions: {
    loadStateFromStorage: 'loadStateFromStorage',
    login: 'login',
    logout: 'logout',
    refresh: 'refresh',
    setToken: 'setToken'
  },
  mutations: {
    setState: 'setState',
    clearModule: 'clearModule'
  },

  storage: {
    token: 'auth-token',
    refreshToken: 'refresh-token',
    keepLoggedIn: 'keep-logged-in'
  }

};
